import React from "react";
import { Grid, TextField } from "@mui/material";

const GeneralStoreInfoSection = ({ form, onChange, errors }) => (
  <>
    <Grid item xs={12}>
      <TextField
        label="Store Display Name"
        fullWidth
        value={form.displayName}
        onChange={(e) => onChange("displayName", e.target.value)}
        error={!!errors.displayName}
        helperText={errors.displayName}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        label="Internal Store ID"
        fullWidth
        value={form.name}
        disabled
        helperText="Auto-generated from display name"
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        label="Store Code (e.g., PAR-01)"
        fullWidth
        value={form.storeCode}
        onChange={(e) => onChange("storeCode", e.target.value.toUpperCase())}
        error={!!errors.storeCode}
        helperText={errors.storeCode}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        label="Address"
        fullWidth
        value={form.address}
        onChange={(e) => onChange("address", e.target.value)}
        error={!!errors.address}
        helperText={errors.address}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        label="City"
        fullWidth
        value={form.city}
        onChange={(e) => onChange("city", e.target.value)}
        error={!!errors.city}
        helperText={errors.city}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        label="Postal Code"
        fullWidth
        value={form.postalCode}
        onChange={(e) => onChange("postalCode", e.target.value)}
        error={!!errors.postalCode}
        helperText={errors.postalCode}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        label="Province"
        fullWidth
        value={form.province}
        onChange={(e) => onChange("province", e.target.value)}
        error={!!errors.province}
        helperText={errors.province}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        label="Country"
        fullWidth
        value={form.country}
        onChange={(e) => onChange("country", e.target.value)}
        error={!!errors.country}
        helperText={errors.country}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        label="Phone"
        fullWidth
        value={form.phone}
        onChange={(e) => onChange("phone", e.target.value)}
        error={!!errors.phone}
        helperText={errors.phone}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        label="Email"
        fullWidth
        value={form.email}
        onChange={(e) => onChange("email", e.target.value)}
        error={!!errors.email}
        helperText={errors.email}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        label="Google Maps URL"
        fullWidth
        value={form.googleMapsUrl}
        onChange={(e) => onChange("googleMapsUrl", e.target.value)}
        error={!!errors.googleMapsUrl}
        helperText={errors.googleMapsUrl}
      />
    </Grid>
  </>
);

export default GeneralStoreInfoSection;
